export default function TestimonialSection() {
  const testimonials = [
    {
      name: "Michael R.",
      role: "Geschäftsführer, E-Commerce",
      text: "Endlich ein Format ohne leere Versprechen. Die Kontakte zu Steuerberatern und Anwälten in Dubai waren Gold wert. Meine Firma läuft jetzt über eine Freezone – alles rechtssicher aufgesetzt.",
      rating: 5
    },
    {
      name: "Thomas K.",
      role: "Investor, Immobilien",
      text: "Ich war skeptisch, weil ich schon viele 'Dubai-Experten' gesehen habe. Aber hier stimmt es: Echte Zugänge, keine Marketingshow. Die Investment-Opportunities waren seriös geprüft.",
      rating: 5
    },
    {
      name: "Andreas M.",
      role: "Unternehmer, SaaS",
      text: "Die Masterclass war der Startschuss. Mittlerweile habe ich nicht nur eine UAE-Struktur, sondern auch drei echte Business-Kontakte aus der Community. Das zahlt sich langfristig aus.",
      rating: 5
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-32 bg-neutral-50 relative overflow-hidden">
      {/* Decorative Element */}
      <div className="absolute top-0 left-0 w-64 sm:w-96 h-64 sm:h-96 bg-yellow-600/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-yellow-600/10 text-yellow-600 px-4 sm:px-6 py-2 rounded-full mb-4 sm:mb-6">
            <i className="ri-chat-quote-line text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
            <span className="font-light tracking-wide text-sm sm:text-base">Stimmen von Mitgliedern</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl mb-4 sm:mb-6 text-gray-900 px-4">
            Was Mitglieder sagen
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="max-w-6xl mx-auto">
          {/* First Row - 2 columns on desktop, 1 on mobile */}
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
            {testimonials.slice(0, 2).map((testimonial, index) => (
              <div
                key={index}
                className="bg-white p-6 sm:p-8 lg:p-10 shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100"
              >
                {/* Stars */}
                <div className="flex gap-1 mb-4 sm:mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-600 text-base sm:text-lg"></i>
                  ))}
                </div>

                {/* Quote */}
                <p className="text-sm sm:text-base lg:text-lg text-gray-700 font-light leading-relaxed mb-6 sm:mb-8">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 sm:gap-4 pt-4 sm:pt-6 border-t border-gray-100">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-yellow-600/10 rounded-full flex-shrink-0">
                    <i className="ri-user-line text-lg sm:text-xl text-yellow-600"></i>
                  </div>
                  <div>
                    <div className="font-light text-gray-900 text-sm sm:text-base">{testimonial.name}</div>
                    <div className="text-xs sm:text-sm text-gray-500 font-light">{testimonial.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Second Row - Single card centered on desktop */}
          <div className="max-w-2xl mx-auto">
            <div className="bg-white p-6 sm:p-8 lg:p-10 shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
              {/* Stars */}
              <div className="flex gap-1 mb-4 sm:mb-6">
                {[...Array(testimonials[2].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-600 text-base sm:text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-sm sm:text-base lg:text-lg text-gray-700 font-light leading-relaxed mb-6 sm:mb-8">
                "{testimonials[2].text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 sm:gap-4 pt-4 sm:pt-6 border-t border-gray-100">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-yellow-600/10 rounded-full flex-shrink-0">
                  <i className="ri-user-line text-lg sm:text-xl text-yellow-600"></i>
                </div>
                <div>
                  <div className="font-light text-gray-900 text-sm sm:text-base">{testimonials[2].name}</div>
                  <div className="text-xs sm:text-sm text-gray-500 font-light">{testimonials[2].role}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Note */}
        <div className="text-center mt-12 sm:mt-16">
          <p className="text-xs sm:text-sm text-gray-500 font-light max-w-2xl mx-auto px-4">
            Alle Testimonials stammen von realen Mitgliedern. Namen wurden aus Datenschutzgründen anonymisiert.
          </p>
        </div>
      </div>
    </section>
  );
}
